import { createContext, useContext, ReactNode } from "react";
import { useWebNews, IWebNews } from "./hooks/useWebNews";

const NewsContext = createContext<IWebNews | undefined>(undefined);

export const NewsProvider = ({ children }: { children: ReactNode }) => {
	const news = useWebNews();
	return <NewsContext.Provider value={news}>{children}</NewsContext.Provider>;
};

export const useNewsContext = () => {
	const context = useContext(NewsContext);
	if (!context) {
		throw new Error("useNewsContext must be used within a NewsProvider");
	}
	return context;
};
